import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Publisher } from '../../../../domain/Publisher';
import { useTranslation } from 'react-i18next';
import { TerritoryRequest } from '../../../../domain/TerritoryRequest';
import { Territory } from '../../../../domain/Territory';

interface Props {
    publisher: Publisher;
    onTerritoryShow: (territory: Territory) => void;
    onRequestAssign: (request: TerritoryRequest) => void;
    onRequestDelete: (request: TerritoryRequest) => void;
}

const MobileAllTerritoryRequestsTable = (props: Props) => {
    const { t } = useTranslation();

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{t("territory")}</TableCell>
                        <TableCell>{t("actions")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.publisher.territoryRequests!.map(request => {
                        return <TableRow key={request.id}>
                            <TableCell>
                                {`${request.territory!.territoryGroup!.name} - ${request.territory!.title}`}
                            </TableCell>
                            <TableCell>
                                <IconButton color="primary" onClick={() => props.onTerritoryShow(request.territory!)}>
                                    <VisibilityIcon />
                                </IconButton>
                                <IconButton color="secondary" onClick={() => props.onRequestAssign(request)}>
                                    <AssignmentIndIcon />
                                </IconButton>
                                <IconButton color="error" onClick={() => props.onRequestDelete(request)}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MobileAllTerritoryRequestsTable;